// Every photo in src/images is picked up automatically.
const ctx = require.context('./images', false, /\.(jpe?g|png|webp)$/i);

const NOT_GALLERY = new Set([
  './mainimg.jpg',
  './bioimg.jpg',
  './Logo.png',
  // Byte-identical copies that ended up in the folder twice.
  './photo_27_2026-09-29_16-37-32.jpg',
  './photo_29_2026-09-29_16-37-32.jpg',
  './photo_33_2026-09-29_16-37-32.jpg',
]);

export const mainImage = ctx('./mainimg.jpg');
export const bioImage = ctx('./bioimg.jpg');
// From behind, facing the wall painted in the logo's colours.
export const contactImage = ctx('./photo_17_2026-09-29_16-15-18.jpg');

// Shots of Patrick on his own, cut up and pasted around the bio like a zine.
export const zine = {
  fist: ctx('./photo_23_2026-09-29_16-37-32.jpg'),
  sideways: ctx('./photo_12_2026-09-29_16-15-18.jpg'),
  stage: ctx('./photo_26_2026-09-29_16-15-18.jpg'),
  park: ctx('./photo_1_2026-09-29_16-15-18.jpg'),
  rehearsal: ctx('./photo_11_2026-09-29_16-37-32.jpg'),
  banner: ctx('./photo_30_2026-09-29_16-37-32.jpg'),
  guitar: ctx('./photo_4_2026-09-29_16-15-18.jpg'),
  // Web-sized copies of the originals in "dj images".
  djLaughing: require('./images/dj images/web/dj_laughing.jpg'),
  djHeadphones: require('./images/dj images/web/dj_headphones.jpg'),
  djHandsUp: require('./images/dj images/web/dj_hands_up.jpg'),
};

export const photos = ctx
  .keys()
  .filter((key) => !NOT_GALLERY.has(key))
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
  .map((key) => ctx(key));
